import React, { useState } from "react";

import Amount from "./Amount";
import Recipient from "./Recipient";
import Review from "./Review";

const views = [
  { id: "amount" },
  { id: "recipient" },
  { id: "review" },
  { id: "pay" },
];

function Wizard(): JSX.Element {
  const [activeView, setActiveView] = useState(0);

  const lastView = activeView === views.length - 1;

  const handleNext = () => {
    if (lastView) {
      // do something
    } else {
      setActiveView(activeView + 1);
    }
  };
  const props = { handleNext };
  // switch between view dynamically
  switch (activeView) {
    case 0:
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <Amount {...props} />;
    case 1:
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <Recipient {...props} />;
    case 2:
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <Review {...props} />;
    case 3:
      return <div>Pay</div>;
    default:
      return <div>Not Found</div>;
  }
}

export default Wizard;
